/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationBatchResponse {
    getFixupPrototypeFunction() { return AppSecopsApplicationBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationBatchResponse>): AppSecopsApplicationBatchResponse {
        let obj = Object.assign(new AppSecopsApplicationBatchResponse(), model);
        AppSecopsApplicationBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationBatchResponse>): AppSecopsApplicationBatchResponse {
        if (!model) return null;
        return AppSecopsApplicationBatchResponse.newInstance(<AppSecopsApplicationBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationBatchResponse) {
        if (!obj) return;

        models.AppSecopsApplicationBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationBatchResponse): boolean {
        Object.setPrototypeOf(obj, AppSecopsApplicationBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AppSecopsApplication.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AppSecopsApplication; };

}
